import type { ReactNode } from 'react'

import { Paper } from '@gto/ui/paper'
import { Typography } from '@gto/ui/typography'

type EmptyStateProps = {
  title: ReactNode
  description?: ReactNode
  action?: ReactNode
}

export const EmptyState = ({ title, description, action }: EmptyStateProps) => {
  return (
    <Paper
      className="rounded-md px-8 py-16 text-center"
      elevation="4"
    >
      <div className="flex flex-col items-center gap-4">
        <Typography
          color="text.primary"
          variant="h6"
        >
          {title}
        </Typography>
        {description != null && (
          <Typography
            className="max-w-[400px]"
            color="text.secondary"
            variant="body2"
          >
            {description}
          </Typography>
        )}
        {action}
      </div>
    </Paper>
  )
}
